import type { Content } from './types'

export const en: Content = {
  lang: 'en',
  hero: {
    h1: 'Your LinkedIn is costing you clients every single day.',
    subtitle:
      'In 3 to 5 days, I transform it into a professional showcase that inspires trust — and converts.',
    cta: 'Talk to Rebeca on WhatsApp',
    ctaHref:
      'https://wa.me/15148095007?text=Hi%20Rebeca%2C%20I%27m%20interested%20in%20LinkedIn%20Signature',
    note: 'Response guaranteed in less than 24h.',
    availability: 'Available in français, español & English 🌐',
  },
  problem: {
    title: 'The truth nobody tells you.',
    paragraphs: [
      'Your ideal clients are searching for you online. They find your profile. And they leave — to someone else.',
      "Not because you're not competent. Because your digital presence doesn't reflect your true value.",
      "It's costing you clients. Every day.",
      "And the worst part? You don't even see it.",
      'Because those clients — never contact you.',
      'They leave silently.',
    ],
  },
  solution: {
    title: "That's exactly what I solve.\nIn 3 to 5 days. Guaranteed.",
    paragraphs: [
      "I'm Rebeca Oliveira, founder of Visibilia.",
      "I'm not an agency. I'm not a marketing student.\nI'm a hands-on professional — 20 years leading an international company.\n5 years building the digital presence of entrepreneurs and SMEs.",
      "I've worked on both sides of the table. I know exactly what a poor online image costs. And what a strong one delivers.",
      {
        text: 'What I create for you — is a LinkedIn profile that makes your ideal clients say:\n"This person, I trust them."',
        quote: true,
      },
    ],
    stats: [
      { value: '20 years', label: 'International\nleadership' },
      { value: '5 years', label: 'Social\nmedia' },
      { value: '3', label: 'Languages\nFR·ES·EN' },
    ],
    langLine: 'FR · ES · EN 🌐',
  },
  offers: {
    title: 'Choose your package.',
    popularBadge: '⭐ MOST POPULAR',
    delaiLabel: '⏱ Timeline: 3 to 5 business days',
    card1: {
      title: '✦ LinkedIn Signature',
      price: '$497',
      originalValue: 'Real value: $900+',
      description:
        "Your profile exists. But it's not working for you. Let's change that.",
      features: [
        'Complete audit of your current profile',
        'Strategic title that positions you',
        'Custom professional banner',
        'About section that converts',
        'Restructured and valued experience',
        'Services section configured',
        'Custom URL',
        '1 launch post ready to publish',
        'LinkedIn mini-guide',
        'Personalized delivery call (15 min)',
      ],
      cta: 'I want to transform my LinkedIn',
      ctaHref:
        'https://wa.me/15148095007?text=Hi%20Rebeca%2C%20I%20want%20the%20LinkedIn%20Signature%20package%20at%20%24497',
    },
    card2: {
      title: '✦ LinkedIn Creation',
      price: '$297',
      description:
        "You don't have a profile yet. Or it's been empty for years. We start from scratch — and we do it right.",
      features: [
        'Complete profile creation',
        'Strategic title + bio',
        'Custom professional banner',
        'About section that converts',
        'Restructured and valued experience',
        'Services section configured',
        'Custom URL',
        '1 launch post ready to publish',
        'LinkedIn mini-guide',
        'Personalized delivery call (15 min)',
      ],
      cta: 'I want to create my LinkedIn',
      ctaHref:
        'https://wa.me/15148095007?text=Hi%20Rebeca%2C%20I%20want%20the%20LinkedIn%20Creation%20package%20at%20%24297',
    },
    helperText:
      "Not sure which one is right for you? Message me — I'll guide you in 5 minutes. ✦",
  },
  faq: {
    title: 'Frequently asked questions.',
    items: [
      {
        q: 'Do I need to be available during the process?',
        a: "No. You fill out a form in 10 minutes. I take care of the rest.\nYou receive your profile in 3 to 5 days. That's it.",
      },
      {
        q: 'How does payment work?',
        a: 'Bank transfer, PayPal or credit card. You choose. No surprises.',
      },
      {
        q: 'What is the exact process?',
        a: '1. You message me on WhatsApp\n2. I send you a form (10 min)\n3. I create your profile\n4. You review and approve\n5. Delivery call (15 min)\nSimple. Fast. Effective.',
      },
      {
        q: 'Is LinkedIn important for my type of business?',
        a: "If your clients, partners or employers search for professionals online —\nyes, absolutely. LinkedIn is the world's #1 professional credibility platform.",
      },
      {
        q: "What if I'm not satisfied?",
        a: 'We review together until your profile perfectly represents you.\nYour satisfaction is my priority. ✦',
      },
    ],
  },
  finalCta: {
    title: 'Your LinkedIn can start working for you this week.',
    subtitle:
      '3 to 5 days. A professional, strategic profile that finally reflects your true value.',
    cta: 'Message Rebeca on WhatsApp',
    ctaHref:
      'https://wa.me/15148095007?text=Hi%20Rebeca%2C%20I%27m%20ready%20to%20transform%20my%20LinkedIn',
    note: 'No commitment. Just a conversation. I respond in less than 24h. ✦',
    closing:
      "You worked hard to build your experience. It's time your LinkedIn showed it. ✦",
  },
}
